import { useMutation, useQueryClient } from "@tanstack/react-query";
import { startCampaign } from "../repositories/MillSetupRepository";

interface UseStartCampaignOptions {
	onSuccess?: (campaignId: number) => void;
	onError?: (error: Error) => void;
}

export const useStartCampaign = ({
	onSuccess,
	onError,
}: UseStartCampaignOptions = {}) => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: startCampaign,
		onSuccess: (campaignId) => {
			queryClient.invalidateQueries({ queryKey: ["millSetup"] });
			onSuccess?.(campaignId);
		},
		onError: (error: Error) => {
			onError?.(error);
		},
	});

	return {
		startCampaign: mutation.mutate,
		isStarting: mutation.isPending,
	};
};
